import colors from './color'
import dateTime from './dateTime'
import session from './session'
import usersRole from './usersRole'
import accessControl from './accessControl'
import width from './width'
import { tableHeight } from './height'
import team from './team'
export const constants = { colors, dateTime, session, usersRole, accessControl, width, tableHeight, team };